import { getChartDefinition } from 'charts/catalog/chartCatalog';
import { resolveChartCardSubtitle } from 'charts/formatters/resolveChartCardSubtitle';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import React, { ReactElement, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { MemoAnalyticsChartGroupPresentational } from './presentational';
import type { AnalyticsChartGroupContainerProps } from '../types';

export function AnalyticsChartGroup({
  sectionLabelId,
  charts,
  runtimeById,
  isChartId,
}: AnalyticsChartGroupContainerProps): ReactElement | null {
  const intl = useIntl();

  const resolveChartTitle = useCallback(
    (titleId: string) => formatTranslation(intl, unsafeTranslationKey(titleId)),
    [intl]
  );

  const resolveChartSubtitle = useCallback(
    (chartId: Parameters<typeof getChartDefinition>[0]) => {
      const definition = getChartDefinition(chartId);
      return resolveChartCardSubtitle(definition, intl);
    },
    [intl]
  );

  return (
    <MemoAnalyticsChartGroupPresentational
      sectionLabel={formatTranslation(intl, sectionLabelId)}
      charts={charts}
      runtimeById={runtimeById}
      isChartId={isChartId}
      resolveChartTitle={resolveChartTitle}
      resolveChartSubtitle={resolveChartSubtitle}
    />
  );
}

export const MemoAnalyticsChartGroup = React.memo(AnalyticsChartGroup);
